import DeviceMonitoring from "./DeviceMonitoringContainer";

export default DeviceMonitoring;
